import React, { useRef, useState } from "react";
import styled, { createGlobalStyle } from "styled-components";
import InputText from "~/components/styled/InputText";
import { theme } from "~/theme";
import { ThemeProvider } from "styled-components";
import Cookies from "js-cookie";

import {
  ConfigContextProvider,
  useConfigContext,
} from "~/providers/ConfigContextProvider";

import { GlobalStyle } from "~/theme/globalstyle";

import { AccessibiliyHelpers } from "~/components/app/AccessibiliyHelpers";
import { AppDefaultHead } from "./AppDefaultHead";
import Button from "../styled/Button";
import { SvgBackground } from "../ui/SvgBackground";

const GlobalStyleLogin = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    background: var(--ikon-hl-color, #ff0);
    font-family: Open-Sans, Helvetica, Sans-Serif;
  }
`;

const LoginContainer = styled.div`
  width: 80%;
  max-width: 500px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
`;

const LoginWrapper = styled.div`
  width: 100%;

  position: relative;

  ${(props) =>
    props.theme.apply("default", (breakpoint: string) => {
      return `
        height: ${props.theme.spacePx(breakpoint, 5)};
        `;
    })}
`;

const LoginInput = styled(InputText)<{ isError: boolean }>`
  width: 100%;
  height: 100%;
  border: none;
  background: ${({ isError }) =>
    isError ? "#f00" : "var(--ikon-hl-color, #ff0)"};
  color: ${({ isError }) => (isError ? "#fff" : "#000")};
  vertical-align: top;
  &::placeholder {
    color: #000 !important;
  }
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
  border-color: ${({ isError }) => (isError ? "#f00" : "#000")};

  ${(props) =>
    props.theme.apply("default", (breakpoint: string) => {
      return `
        ${props.theme.textStyle(breakpoint, `h2Heading`)};
        font-weight: bold;
        `;
    })}
`;

const LoginButton = styled(Button)`
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  opacity: 1;
  transition: opacity 0.3s;

  @media (any-pointer: fine) {
    &:hover {
      opacity: 0.75;
    }
  }

  ${(props) =>
    props.theme.apply("default", (breakpoint: string) => {
      return `
        ${props.theme.textStyle(breakpoint, `h2Heading`)};
        width: ${props.theme.spacePx(breakpoint, 6)};
        height: ${props.theme.spacePx(breakpoint, 6)};
        `;
    })}
`;

export const Login = ({ cookieName = "preview", password }: { cookieName?: string; password?: string; }) => {
  const inputRef = useRef() as React.MutableRefObject<HTMLInputElement>;
  const [isError, setIsError] = useState(false);

  const config = useConfigContext();
  const expectedPassword = (password ?? config.previewPwd ?? "").trim();

  return (
    <>
      <ThemeProvider theme={theme}>
        <AccessibiliyHelpers />
        <ConfigContextProvider>
          <AppDefaultHead />
          <GlobalStyle />
          <GlobalStyleLogin />
          <form
            onSubmit={(event) => {
              event.preventDefault();

              if (
                expectedPassword &&
                inputRef.current.value.trim() === expectedPassword
              ) {
                Cookies.set(cookieName, "yes", { expires: 365 });
                window.location.reload();
              } else {
                setIsError(true);
              }
            }}
          >
            <LoginContainer>
              <LoginWrapper>
                <LoginInput
                  ref={inputRef}
                  placeholder="Password?"
                  type="password"
                  isError={isError}
                  onChange={() => setIsError(false)}
                />
                <LoginButton>
                  <SvgBackground
                    type="arrow"
                    position="center center"
                    width="100%"
                    height="100%"
                  />
                </LoginButton>
              </LoginWrapper>
            </LoginContainer>
          </form>
        </ConfigContextProvider>
      </ThemeProvider>
    </>
  );
};

export default Login;
